<template>
<v-container grid-list-lg>
	<v-layout column>
		<v-layout v-for="history in historys" column>
			<v-layout>
				<v-flex>
					<h2 class="title">
						<span class="user" v-if="history.user" :title="history.user.email">
							{{history.user.name + ' -- '}}
						</span>
						<span>
							{{$t(`common.${history.type.toLowerCase()}`)}}
						</span> : {{history.created_at}}
					</h2>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-flex md4>
					<h4>{{$t('history.new_field')}}</h4>
				</v-flex>
				<v-flex md4 class="col">
					<h4>{{$t('history.old')}}</h4>
				</v-flex>
				<v-flex md4>
					<h4>{{$t('history.new')}}</h4>
				</v-flex>
			</v-layout>
			<v-layout
				v-for="(item, key) in Array.isArray(history.content.old) ? history.content.new : history.content.old"
				class="table"
			>
				<v-flex md4>
					{{findLocale(key)}}
				</v-flex>
				<v-flex md4 class="col value">
					{{history.content.old[key]}}
				</v-flex>
				<v-flex md4 class="value">
					{{history.content.new[key]}}
				</v-flex>
			</v-layout>
		</v-layout>
		<div class="line"></div>
	</v-layout>
</v-container>
</template>

<script>
import TextItem from '../TextItem'
import Address from '../Address'
import * as locales from '../../localization'

export default {
	props: {
		historys: {
			type: Array,
			default: []
		}
	},
	components: {
		TextItem,
		Address
	},
	methods: {
		fields(field) {
			return Object.keys(field).sort()
		},
		findLocale(key) {
			const { locale } = this.$store.state.i18n
			const mnemonic = this.$store.state.i18n.translations[locale]
			const groups = Object.keys(locales[locale])
			const group = groups.find(group =>
				mnemonic.hasOwnProperty(`${group}.${key}`)
			)
			return this.$t(`${group}.${key}`)
		}
	}
}
</script>

<style scoped>
.title {
	text-align: center;
	margin-top: 10px;
	padding-top: 10px;
	border-top: 1px solid #dedede;
}
.title:first-letter {
	text-transform: uppercase;
}
.line {
	width: 100%;
	height: 25px;
	border-bottom: 3px solid #dedede;
	margin-bottom: 25px;
}
h2,
h3 {
	width: 100%;
	text-align: center;
}

.table:nth-child(2n) {
	background: rgba(216, 198, 202, 0.45);
}
.table {
	margin-top: 10px;
}
.col {
	border-right: 1px solid #dedede;
	border-left: 1px solid #dedede;
}
.user {
	cursor: pointer;
	color: #000;
	opacity: 0.7;
}
.value {
	word-break: break-word;
	overflow: hidden;
}
</style>
